export default __webpack_public_path__ + "static/media/systemHangers2.28225385.jpg";